<template>
    <el-row class="btm-action">
        <el-pagination
            v-if="count > 0"
            class="pagination"
            :page-size="size"
            layout="total, prev, pager, next, jumper"
            :total="count"
            :current-page="pageNo"
            @current-change="onChangeCurrentPage">
        </el-pagination>
    </el-row>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    size: {
      type: Number,
      default: 20
    },
    count: {
      type: Number,
      default: 0
    },
    pageNo: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {

    }
  },
  methods: {
    onChangeCurrentPage (page) {
      // this.pageNo = page
      this.$emit('changePage', page)
    }
  }
}
</script>

<style scoped>
    .btm-action {
        margin-top: 20px;
        text-align: center;
    }
</style>
